// extracted by mini-css-extract-plugin
export default {"contacts_list":"ContactsList_contacts_list__G9kNw"};